import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';


class EraControl extends Component {
  constructor (props) {
    super(props);
    this.state = { menuIsOpen: false };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu () {
    this.setState({ menuIsOpen: !this.state.menuIsOpen });
  }

  render () {
    const { breakpoint, match, hasEras, activeEra, erasItems, erasBySlug } = this.props;
    if (!hasEras) {
      return null;
    }
    const classes = classNames({
      'timeline-eras-menu': true,
      open: this.state.menuIsOpen,
    });

    const mobileUI = breakpoint.lessThan.lg && (
      <nav className={classes} onClick={this.toggleMenu}>
        <div className="toggle" />
        {this.state.menuIsOpen
          ? (
            <Link to={`${match.url}/${activeEra}`}>
              <h6 className="m-0">{erasBySlug[activeEra].name}</h6>
            </Link>
          ) : <h6 className="m-0">{erasBySlug[activeEra].name}</h6>
        }
        <div className="sub">
          {erasItems.filter(slug => slug !== activeEra).map(slug => (
            <Link key={slug} to={`${match.url}/${slug}`}>
              <h6 className="m-0">{erasBySlug[slug].name}</h6>
            </Link>
          ))}
        </div>
      </nav>
    );

    return mobileUI || (
      <div className="d-flex">
        {erasItems.map(slug => (
          activeEra === slug ? (
            <div key={slug} className="timeline-era-tab active p-3">
              <h4 className="m-0">{erasBySlug[slug].name}</h4>
            </div>
          ) : (
            <Link key={slug} to={`${match.url}/${slug}`} className="timeline-era-tab p-3">
              <h4 className="m-0">{erasBySlug[slug].name}</h4>
            </Link>
          )
        ))}
      </div>
    );
  }
}

EraControl.propTypes = {
  titleId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ breakpoint, titles }, ownProps) => ({
  breakpoint,
  ...titles[ownProps.titleId],
});

export default withRouter(connect(mapStateToProps)(EraControl));



// WEBPACK FOOTER //
// ./src/components/Timeline/EraControl.js